import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Button } from "Components/_Shared/Buttons/Button";
import { Flex } from "Components/_Shared/Core/Flex";
import { Empty } from "Components/_Shared/Empty";
import { IconBadge } from "Components/_Shared/IconBadge";
import { QuestionnaireStatus } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useQuestionnaireContext } from "./QuestionnaireContext";
import { isExpiredStatus } from "./utils";

type Props = {
  onReEvaluate: () => void;
  status: QuestionnaireStatus;
};

const getContent = (status: QuestionnaireStatus) => {
  if (isExpiredStatus(status)) {
    return {
      titleKey: Resources.Questionnaire.Expired.Title,
      textKey: Resources.Questionnaire.Expired.Text,
      actionKey: Resources.Questionnaire.Expired.Action,
    };
  }

  return {
    titleKey: Resources.Questionnaire.QuestionsModified.Title,
    textKey:
      status === QuestionnaireStatus.nsure_questions_changed
        ? Resources.Questionnaire.QuestionsModified.TextNsureChanged
        : Resources.Questionnaire.QuestionsModified.TextGoalsChanged,
    actionKey: Resources.Questionnaire.QuestionsModified.Action,
  };
};

export const QuestionnaireReEvaluationRequired = ({ onReEvaluate, status }: Props) => {
  const { t } = useResource();
  const { isReadOnly } = useQuestionnaireContext();

  const { titleKey, textKey, actionKey } = getContent(status);

  return (
    <Flex pt={Spacing.XXL} justifyContent="center">
      <Empty
        title={t(titleKey)}
        text={t(textKey)}
        icon={<IconBadge color="warning" icon={<WarningAmberIcon sx={{ fontSize: 35 }} />} />}
        actions={
          <Button variant="contained" onClick={onReEvaluate} disabled={isReadOnly}>
            {t(actionKey)}
          </Button>
        }
      />
    </Flex>
  );
};
